<div class="container min-content-height" id="logout-container">
  <div class=" logout_boxouter">
    <div class="img-logo"><img  src="/assets/tfb-acctmgmt/images/TMO_Logo.png" alt="Logo" /></div>
  </div>  
  <div class="row logout_box">
    <mat-card appearance="outlined" class="logout-card">
      <mat-card-header class="logout-header">
        <mat-card-title class="logout-name"><h2>{{logout_name}}</h2></mat-card-title>
      </mat-card-header>

      <hr>

      <mat-card-content>
        <h4 class='thank_you'>{{logout_content1}}</h4>
				<p class='logout-content'>{{logout_content2}}</p>
      </mat-card-content>
      <mat-card-actions class="logout-link">
        <a id='tmo_login_redirect_anchr' (click)="reLogin()">{{relogin}}</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>